import type { RouteLocationNormalized } from 'vue-router'

/**
 * Whether this navigation should show the branded page loader.
 * Heavy routes only (`meta.pageLoader`). Skips query-only pagination.
 */
export function shouldStartFairPageLoader(
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
): boolean {
  if (!to.meta.pageLoader) return false

  // Deep link / first client navigation onto a heavy page
  if (!from.name) return true

  // FE-003.2 — home used to be excluded here, so pressing Back onto it showed raw,
  // half-dressed content: there is no <KeepAlive>, the page remounts and refetches like
  // any other. Warm caches only make the overlay short, not useless.
  if (to.name !== from.name) return true

  switch (to.name) {
    case 'search':
      return (
        to.params.searchText !== from.params.searchText ||
        to.query.image !== from.query.image
      )
    case 'product':
      // Entering product from another route only. Intra-product color/size
      // URL replaces must not flash the branded overlay.
      return from.name !== 'product'
    case 'brand-details':
      return to.params.brandName !== from.params.brandName
    case 'recommendation-banners':
      return to.params.bannerId !== from.params.bannerId
    case 'sim':
      return to.fullPath !== from.fullPath
    default:
      return to.path !== from.path
  }
}
